import * as React from 'react';
export const remoteSvg = React.forwardRef(function remoteSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#5700FF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M24.2 21.84h.23v5.3h-.87c-5.68 0-8.96-3.22-8.96-8.46v-2.7l1.84-.46a2.98 2.98 0 0 0 2.18-2.26 2.94 2.94 0 0 0-1.08-2.93 2.99 2.99 0 0 0-4.8 2.33V24.2H7V12.46A8.63 8.63 0 0 1 15.71 4a8.69 8.69 0 0 1 8.43 6.26c.52 1.89.35 3.9-.48 5.68a8.56 8.56 0 0 1-3.24 3.64c.48 1.9 1.48 2.26 3.72 2.26',
      fill: '#fff',
    }),
  );
});
remoteSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var remote = {
  category: 'brand',
  colorable: false,
  name: 'remote',
  svg: remoteSvg,
};
